<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table"
               matSort matSortActive="_id" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="_id">
        <mat-header-cell *matHeaderCellDef mat-sort-header="_id">Group #</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button mat-mini-fab class="button-32 no-shadow agents-summary" color="accent" (click)="showGroupCallLogsDetails(row)" matTooltip="View Group Call Logs">
            <mat-icon>description</mat-icon>
          </button>
          <button mat-mini-fab class="button-32 no-shadow agents-summary" color="primary" (click)="showGroupDetailsDetails(row)" matTooltip="View Agents Summary">
            <mat-icon>group</mat-icon>
          </button>
          {{row._id }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Group Name</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.type}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef mat-sort-header="count">Total Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.count}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="answered">
        <mat-header-cell *matHeaderCellDef mat-sort-header="answered">Answered</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.answered}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="missed">
        <mat-header-cell *matHeaderCellDef mat-sort-header="missed">Abandoned</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.missed}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="durationTalk">
        <mat-header-cell *matHeaderCellDef mat-sort-header="durationTalk">Talk</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.durationTalkFormatted}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="durationIvr">
        <mat-header-cell *matHeaderCellDef mat-sort-header="durationIvr">IVR</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.durationIvrFormatted}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="durationRing">
        <mat-header-cell *matHeaderCellDef mat-sort-header="durationRing">Ring</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.durationRingFormatted}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="durationHold">
        <mat-header-cell *matHeaderCellDef mat-sort-header="durationHold">Hold</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.durationHoldFormatted}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="durationIdle">
        <mat-header-cell *matHeaderCellDef mat-sort-header="durationIdle">IDLE</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.durationIdleFormatted}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rwCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="rwCount">Redirected while Waiting</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.rwCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rrCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="rrCount">Redirected while Ringing</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.rrCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="hwCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="hwCount">Hung Up while Waiting</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.hwCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="hrCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="hrCount">Hung Up while Ringing</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.hrCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="raCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="raCount">Redirected Anonymous Calls</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.raCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="hbCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="hbCount">Maximum Calls Reached</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.hbCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="userCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="userCount">Callers Redirected to Other Destinations</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.userCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="soapCount">
        <mat-header-cell *matHeaderCellDef mat-sort-header="soapCount">Redirected Due to Server Application</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.soapCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="surveys">
        <mat-header-cell *matHeaderCellDef>Survey Results, Avg.</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div *ngFor="let survey of row.surveys">
            <div>
              <span>{{survey.accountName}}</span>
              <span style="padding-left: 5px">({{survey.avg | number:'1.2-2'}})</span>
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
